<template>
  <q-field ref="fieldRef" :rules="rules" />
</template>

<script setup>
import { ref, toRef, computed, onMounted } from "vue"

import { useValidators } from "@/composables/useValidators.js"

const validators = useValidators()

const props = defineProps({
  rules: Array
})

const fieldRef = ref(null)

onMounted(() => validators.watchRules(toRef(props, "rules"), fieldRef))

const hasError = computed(() => fieldRef.value?.hasError ?? false)

defineExpose({ validate: () => fieldRef.value.validate(), hasError })
</script>

<style lang="scss" scoped>
.q-field {
  padding-bottom: 0;
  max-width: 400px;
}

:deep(.q-field__control) {
  display: none;
}

:deep(.q-field__bottom) {
  position: relative;
  padding-top: 0;
  transform: none;
  min-height: 0;
}
</style>
